import a from "react";
function l(r) {
  return r.replace(/-([a-z])/g, (n) => n[1].toUpperCase());
}
function f(r) {
  return r.split(";").reduce((n, o) => {
    let [t, e] = o.split(":");
    return t = t == null ? void 0 : t.trim(), e = e == null ? void 0 : e.trim(), t && e && (n[l(t)] = e), n;
  }, {});
}
function c(r) {
  if (Array.isArray(r))
    return r.map((i) => c(i));
  if (!a.isValidElement(r))
    return r;
  const n = {
    class: "className",
    for: "htmlFor",
    targetAttr: "targetattr"
    // Add more attribute conversions here as needed
  }, o = Object.keys(r.props).reduce((i, s) => {
    let p = r.props[s];
    s === "style" && typeof p == "string" && (p = f(p));
    const u = n[s] || s;
    return i[u] = p, i;
  }, {});
  o.key = r.key;
  const t = a.Children.map(r.props.children, (i) => c(i));
  return a.createElement(r.type, o, t);
}
export {
  c as convertAttributesInElement
};
